module.exports = "<div class=\"alert alert-warning alert-dismissible fade show\" role=\"alert\">\r\n  <strong>Ocurrió algo inesperado!</strong> {{message}}\r\n  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\r\n    <span aria-hidden=\"true\" (click)=\"closeMessage()\">&times;</span>\r\n  </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/message/message.component.html
// module id = ../../../../../src/app/components/message/message.component.html
// module chunks = main